export const selectSupplierPricingsBySupplier = (state, supplierId) =>
  state.supplierPricing && state.supplierPricing.pricingsBySupplier
    ? state.supplierPricing.pricingsBySupplier[supplierId] || []
    : [];

export const selectSupplierPricingLoading = (state) =>
  state.supplierPricing ? state.supplierPricing.loading : 'idle';

export const selectSupplierPricingError = (state) =>
  state.supplierPricing ? state.supplierPricing.error : null;
